import { Button, Card } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"
import { useState } from 'react'

export default function DeleteCard({ role, getRoles, showDeleteButton = false, onDelete, onCancel }) {
  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [saveLoading, setSaveLoading] = useState(false)
  const [showCard, setShowCard] = useState(false)

  const handleShowCard = () => setShowCard(true)
  const handleCloseCard = () => {
    setShowCard(false)
    if (onCancel) onCancel()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaveLoading(true)
    try {
      const response = await fetch(`${url}/meetingrole/${role._id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
      })
      if (response.status === 200) {
        getRoles() // Refresh the role list
        setShowCard(false)
        if (onDelete) onDelete() // Notify parent component
      } else {
        console.error(response)
        toast.error(`Failed to delete Role ${role.name}`, { position: 'bottom-left' })
      }
    } catch (error) {
      console.error(error)
      toast.error(`Failed to delete role ${role.name}`, { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }

  return (
    <>
      {showDeleteButton && !showCard ? (
        <Button
          variant="danger"
          className='mb-1 float-end'
          onClick={handleShowCard}
        >
          Delete Role
        </Button>
      ) : (
        showCard && (
          <Card className="text-center mt-2" data-bs-theme={'dark'}>
            <Card.Header>
              <Card.Title>
                Delete Role: <br /> {role.name}
              </Card.Title>
            </Card.Header>
            <Card.Body>
              Are you sure you want to delete this Role?
            </Card.Body>
            <Card.Footer>
              {saveLoading
                ? (
                  <>
                    <AppLoader />
                    Deleting Role ...
                  </>
                ) : (
                  <>
                    <Button variant="danger" type='submit' onClick={handleSubmit}>
                      Delete Role
                    </Button>
                    <Button variant="dark" onClick={handleCloseCard}>
                      Cancel
                    </Button>
                  </>
                )}
            </Card.Footer>
          </Card>
        )
      )}
    </>
  )
}
